import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import FairePayWidgetOnInvoicesPagePage from "@faire/prototype-playground/workspace/jb/faire-pay-widget-invoices-page";
import FairePayCreditsPage from "@faire/prototype-playground/workspace/jb/faire-pay-credits";
import { withCompass } from "../../components/compass/withCompass";
const OpeningSoonIdentityVerificationPage = lazy(
  () => import("../../pages/OpeningSoonIdentityVerificationPage")
);
const RetailerPaymentBalancePage = withCompass(
  () => import("../../pages/RetailerPaymentBalancePage")
);
const OrderIssueResponsePage = lazy(
  () => import("../../pages/OrderIssueResponsePage")
);
const ReportIssuesFlowPage = withCompass(
  () => import("../../pages/ReportIssuesFlowPage")
);

export function JessBrownRoutes() {
  return (
    <Switch>
      <Route path="/jb/faire-pay-credits" component={FairePayCreditsPage} />
      <Route path="/jb/faire-pay-widget-invoices-page" component={FairePayWidgetOnInvoicesPagePage} />
      <Route
        path="/jb/opening-soon-identity-verification"
        component={OpeningSoonIdentityVerificationPage}
      />
      <Route
        path="/jb/retailer-payment-balance"
        component={RetailerPaymentBalancePage}
      />
      <Route
        path="/jb/order-issue-response"
        component={OrderIssueResponsePage}
      />
      <Route path="/jb/report-issues-flow" component={ReportIssuesFlowPage} />
    </Switch>
  );
}

export const slug = "jb";
